import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-core-dialog',
    templateUrl: './core-dialog.component.html',
    styleUrls: ['./core-dialog.component.scss'],
    standalone: false
})
export class CoreDialogComponent {
  matDialog = inject(MatDialog)
  closer() {
    this.matDialog.closeAll();
  }
}
